var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._b({class:{ 'text-input': true, invalid: _vm.invalid },attrs:{"type":"text","autofocus":""},on:{"input":_vm.handleInput,"blur":_vm.handleBlur}},'input',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }